import { getOrderById } from 'API/order/getOrderById';
import { IOrderDetailsData } from '../../../ui-toolkit/orders/interfaces/IOrderDetailsData';
import { transformServiceToForm } from './transformServiceToForm';
import { Logger } from '../../../ui-toolkit/logging/LoggerService';

export const doLoadOrderAction = async (id: string): Promise<IOrderDetailsData> => {
  try {
    const result = await getOrderById({ orderId: id });
    return transformServiceToForm(result);
  } catch (e) {
    Logger.error('Error: get order information', e);
    return Promise.reject('Error: get order information');
  }
};
